export default __webpack_public_path__ + "static/MediaMainBannerMobile-f2fec6f5fbe1b14d344013cfb8626cf5.webp";